(() => {
  "use strict";

  class SChocolateToxicityCalculator extends HTMLElement {
    connectedCallback() {
      if (this.__ctcInitialized) return;
      this.__ctcInitialized = true;

      var root=this;

      var root=this;

        var q=function(sel){return root.querySelector(sel)};
        var qa=function(sel){return Array.prototype.slice.call(root.querySelectorAll(sel))};
        var form=q("#aavChocForm");
        var species="dog";
        var lastResult=null;

        var PRODUCTS={
          milk:{label:"Milk chocolate",min:2.3,max:2.3},
          dark_unknown:{label:"Dark or semisweet chocolate, cocoa % unknown",min:5.3,max:15.5},
          bakers:{label:"Unsweetened or baker's chocolate",min:15.5,max:15.5},
          cocoa_powder:{label:"Pure cocoa powder",min:28.5,max:28.5},
          cocoa_hulls:{label:"Cocoa bean hulls or cocoa mulch",min:9,max:9},
          white:{label:"White chocolate",min:.04,max:.04}
        };
        var CARE_ORDER=["monitor","call","urgent","emergency"];
        var TIME_LABELS={unknown:"Unknown",under_2h:"Less than 2 hours","2_6h":"2 to 6 hours","6_12h":"6 to 12 hours",over_12h:"More than 12 hours"};
        var FLAG_LABELS={
          mild_signs:"vomiting, diarrhoea, restlessness or panting",
          severe_signs:"tremors, seizure, collapse, breathing difficulty or abnormal heartbeat",
          raisins:"raisins, sultanas, grapes or currants",caffeine:"coffee, espresso or added caffeine",
          cannabis:"cannabis or THC",alcohol:"alcohol",macadamia:"macadamia nuts",wrapper:"swallowed packaging",
          heart:"heart disease or arrhythmia",seizure:"a seizure disorder",pregnant:"pregnancy or nursing"
        };

        function numberOf(el){var n=Number(el.value);return Number.isFinite(n)?n:NaN}
        function toKg(v,u){return u==="lb"?v*.45359237:v}
        function toGrams(v,u){return u==="oz"?v*28.349523125:v}
        function maxCare(a,b){return CARE_ORDER[Math.max(CARE_ORDER.indexOf(a),CARE_ORDER.indexOf(b))]}
        function bandForDose(d){if(d>=60)return"critical";if(d>=40)return"cardiac";if(d>=20)return"mild";return"below"}
        function checked(container){return qa(container+" input:checked").map(function(el){return el.value})}
        function has(list,value){return list.indexOf(value)!==-1}
        function esc(value){return String(value).replace(/[&<>"']/g,function(ch){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[ch]})}
        function fmt(v,p){
          if(!Number.isFinite(v))return"—";
          if(v>0&&p<=1&&v<.05)return"<0.1";
          return v.toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:p});
        }
        function range(min,max,p){
          if(!Number.isFinite(min)||!Number.isFinite(max))return"Not calculated";
          return Math.abs(max-min)<.005?fmt(max,p):fmt(min,p)+" to "+fmt(max,p);
        }
        function doseFmt(v){
          if(!Number.isFinite(v))return"—";
          var actual=bandForDose(v),places=1,shown=Number(v.toFixed(places));
          while(places<6&&bandForDose(shown)!==actual){places++;shown=Number(v.toFixed(places))}
          if(bandForDose(shown)!==actual){
            var boundary={below:20,mild:40,cardiac:60}[actual];
            return boundary?"<"+boundary:fmt(v,6);
          }
          return fmt(v,places);
        }
        function doseRange(min,max){
          if(!Number.isFinite(min)||!Number.isFinite(max))return"Not calculated";
          return Math.abs(max-min)<.0000001?doseFmt(max):doseFmt(min)+" to "+doseFmt(max);
        }
        function setError(el,msg,show){el.setAttribute("aria-invalid",show?"true":"false");msg.hidden=!show}

        function invalidateResult(){
          if(!lastResult)return;
          lastResult=null;
          q("#aavChocResult").hidden=true;
          q("#aavChocEmpty").hidden=false;
          q("#aavChocEmptyTitle").textContent="Details changed";
          q("#aavChocEmptyText").textContent="Recalculate to replace the previous result. Copy and print stay disabled until the new details are checked.";
          qa('[data-action="print"]').forEach(function(btn){btn.disabled=true});
        }

        function immediateMessage(){
          var flags=checked("#aavChocFlags"),xylitol=q("#aavChocXylitol").value;
          if(has(flags,"severe_signs"))return"Emergency: severe signs are already present. Call the nearest emergency clinic and leave now. You do not need to finish the calculator.";
          if(xylitol!==""&&xylitol!=="no")return species==="dog"
            ?"Possible xylitol exposure: contact a veterinarian, emergency clinic or animal poison service immediately. The chocolate calculation does not measure xylitol."
            :"Possible xylitol exposure: contact a veterinarian or animal poison service now. The chocolate calculation does not measure xylitol.";
          if(has(flags,"caffeine"))return"Added caffeine is present: contact the nearest emergency vet now. The chocolate estimate cannot include the extra caffeine.";
          if(has(flags,"mild_signs"))return"Clinical signs are already present: contact a veterinarian or animal poison service immediately rather than waiting for a dose result.";
          return"";
        }

        function syncImmediateAlert(moveFocus){
          var text=immediateMessage(),box=q("#aavChocImmediate");
          box.hidden=!text;
          box.textContent=text;
          if(text){
            var live=q("#aavChocLive");
            live.setAttribute("aria-live","assertive");
            live.textContent=text;
            if(moveFocus){box.focus();box.scrollIntoView({behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"center"})}
          }else if(!lastResult){
            q("#aavChocLive").setAttribute("aria-live","polite");
            q("#aavChocLive").textContent="";
          }
          return!!text;
        }

        function concentration(type,percent,custom){
          if(PRODUCTS[type])return{label:PRODUCTS[type].label,min:PRODUCTS[type].min,max:PRODUCTS[type].max,calculable:true};
          if(type==="cocoa_percent"){
            var c=15.5*(percent/100);
            return{label:fmt(percent,1)+"% cocoa chocolate",min:c,max:c,calculable:true};
          }
          if(type==="custom")return{label:"Custom methylxanthine concentration",min:custom,max:custom,calculable:true};
          if(type==="mixed")return{label:"Mixed recipe or prepared product",calculable:false,reason:"The final brownie, cake, cookie or drink weight does not reveal how much cocoa or chocolate it contains. Use the actual chocolate ingredient or obtain direct poison advice."};
          return{label:"Chocolate type unknown",calculable:false,reason:"The methylxanthine concentration cannot be estimated safely without the product type."};
        }

        function weightLooksOdd(kg){
          return species==="dog"?(kg<.3||kg>120):(kg<.5||kg>25);
        }
        function updateWeightConfirmation(){
          var weight=numberOf(q("#aavChocWeight"));
          var kg=toKg(weight,q("#aavChocWeightUnit").value);
          var odd=Number.isFinite(kg)&&kg>0&&weightLooksOdd(kg);
          q("#aavChocWeightConfirmWrap").hidden=!odd;
          if(!odd){
            q("#aavChocWeightConfirm").checked=false;
            q("#aavChocWeightConfirmError").hidden=true;
          }
          refreshChecks();
        }

        function validate(){
          var weightEl=q("#aavChocWeight"),typeEl=q("#aavChocType"),amountEl=q("#aavChocAmount"),xylitolEl=q("#aavChocXylitol");
          var percentEl=q("#aavChocPercent"),customEl=q("#aavChocCustom");
          var weight=numberOf(weightEl),amount=numberOf(amountEl),percent=numberOf(percentEl),custom=numberOf(customEl);
          var type=typeEl.value,amountUnknown=q("#aavChocAmountUnknown").checked;
          var badWeight=!(weight>0),badType=!type,badAmount=!amountUnknown&&!(amount>0);
          var badPercent=type==="cocoa_percent"&&!(percent>=1&&percent<=100);
          var badCustom=type==="custom"&&!(custom>0),badXylitol=!xylitolEl.value;
          setError(weightEl,q("#aavChocWeightError"),badWeight);
          setError(typeEl,q("#aavChocTypeError"),badType);
          setError(amountEl,q("#aavChocAmountError"),badAmount);
          setError(percentEl,q("#aavChocPercentError"),badPercent);
          setError(customEl,q("#aavChocCustomError"),badCustom);
          setError(xylitolEl,q("#aavChocXylitolError"),badXylitol);
          var kg=badWeight?NaN:toKg(weight,q("#aavChocWeightUnit").value);
          var badConfirm=Number.isFinite(kg)&&weightLooksOdd(kg)&&!q("#aavChocWeightConfirm").checked;
          q("#aavChocWeightConfirmError").hidden=!badConfirm;
          var invalid=badWeight||badType||badAmount||badPercent||badCustom||badXylitol||badConfirm;
          if(invalid){
            var first=root.querySelector('[aria-invalid="true"]');
            if(first)first.focus();
            else if(badConfirm)q("#aavChocWeightConfirm").focus();
            return null;
          }
          return{weight:weight,type:type,amount:amount,amountUnknown:amountUnknown,percent:percent,custom:custom};
        }

        function assess(v){
          var weightKg=toKg(v.weight,q("#aavChocWeightUnit").value);
          var grams=v.amountUnknown?null:toGrams(v.amount,q("#aavChocAmountUnit").value);
          var product=concentration(v.type,v.percent,v.custom);
          var flags=checked("#aavChocFlags"),patientFlags=checked("#aavChocPatientFlags");
          var doseMin=null,doseMax=null,totalMin=null,totalMax=null,band=null;
          if(product.calculable&&grams!==null){
            totalMin=grams*product.min;totalMax=grams*product.max;
            doseMin=totalMin/weightKg;doseMax=totalMax/weightKg;
            band=bandForDose(doseMax);
          }
          var care=band?{below:"monitor",mild:"call",cardiac:"urgent",critical:"emergency"}[band]:"call";
          var reasons=[];
          if(species==="cat"){care=maxCare(care,"call");reasons.push("canine thresholds are not validated feline thresholds")}
          if(patientFlags.length){care=maxCare(care,"call");reasons.push("a patient factor lowers the threshold for direct advice")}
          if(v.amountUnknown){care=maxCare(care,"call");reasons.push("the amount is unknown")}
          if(!product.calculable){care=maxCare(care,"call");reasons.push("the concentration cannot be calculated safely")}
          if(has(flags,"wrapper")){care=maxCare(care,"call");reasons.push("packaging may be swallowed")}
          if(has(flags,"macadamia")&&species==="dog"){care=maxCare(care,"call");reasons.push("macadamia nuts create a separate dog toxin exposure")}
          if(has(flags,"raisins")){care=maxCare(care,species==="dog"?"urgent":"call");reasons.push("grape or raisin exposure is separate")}
          if(has(flags,"alcohol")){care=maxCare(care,"urgent");reasons.push("alcohol is not measured by this calculator")}
          if(has(flags,"cannabis")){care=maxCare(care,"urgent");reasons.push("cannabis or THC is not measured")}
          if(has(flags,"caffeine")){care=maxCare(care,"emergency");reasons.push("added caffeine makes the estimate incomplete")}
          var xylitol=q("#aavChocXylitol").value;
          if(xylitol!=="no"){
            care=maxCare(care,species==="dog"?"emergency":"call");
            reasons.push("xylitol is listed or cannot be excluded");
          }
          if(has(flags,"mild_signs")){care=maxCare(care,"urgent");reasons.push("clinical signs are present")}
          if(has(flags,"severe_signs")){care="emergency";reasons.push("severe clinical signs are present")}
          return{
            species:species,weightEntered:v.weight,weightUnit:q("#aavChocWeightUnit").value,weightKg:weightKg,
            amountEntered:v.amount,amountUnit:q("#aavChocAmountUnit").value,amountUnknown:v.amountUnknown,grams:grams,
            type:v.type,product:product,time:q("#aavChocTime").value,xylitol:xylitol,flags:flags,patientFlags:patientFlags,
            totalMin:totalMin,totalMax:totalMax,doseMin:doseMin,doseMax:doseMax,band:band,care:care,reasons:reasons
          };
        }

        function actionCopy(r){
          if(has(r.flags,"severe_signs"))return{title:"Emergency veterinary care now",text:"Severe clinical signs override the dose estimate. Call the nearest emergency clinic and leave now."};
          if(r.xylitol!=="no"&&r.species==="dog")return{title:"Possible xylitol exposure: emergency advice now",text:"The chocolate number does not measure xylitol. Contact a veterinarian, emergency clinic or animal poison service immediately and take the ingredient list."};
          if(has(r.flags,"caffeine"))return{title:"Added caffeine makes this an emergency",text:"The displayed dose does not include the extra caffeine. Contact the nearest emergency vet now."};
          if(r.care==="emergency")return{title:"Emergency veterinary care now",text:"This estimated exposure can cause severe neurologic or cardiovascular effects. Call ahead and go to the nearest emergency clinic now."};
          if(r.care==="urgent")return{title:"Urgent veterinary assessment now",text:"Contact a veterinarian or animal poison service immediately. An in-person assessment may be required even if your pet currently looks fairly well."};
          if(r.care==="call")return{title:"Contact a vet or animal poison service now",text:"Prompt advice is recommended. Do not wait for symptoms, particularly while veterinary decontamination may still be an option."};
          return{title:"Below the published mild-sign threshold",text:"Methylxanthine poisoning is less likely at this estimate, but this is not zero risk. Monitor closely and call a vet if the estimate may be wrong or any sign develops."};
        }

        function doseCopy(r){
          if(!r.band)return{title:"A reliable dose could not be calculated",desc:r.product.reason||(r.amountUnknown?"The amount eaten is unknown.":"More information is required.")};
          var d={
            below:{title:"Below the published canine mild-sign threshold",desc:"Mild methylxanthine signs are generally reported from about 20 mg/kg, but gastrointestinal upset or pancreatitis can still occur and product concentrations vary."},
            mild:{title:"Mild clinical signs may occur",desc:"At 20 mg/kg or above, vomiting, diarrhoea, increased thirst and restlessness may occur. Contact a vet or poison service promptly."},
            cardiac:{title:"Cardiotoxic effects may occur",desc:"At about 40 to 50 mg/kg, tachycardia and abnormal heart rhythms may occur. Urgent veterinary assessment is recommended."},
            critical:{title:"Severe neurologic effects may occur",desc:"At 60 mg/kg or above, tremors and seizures may occur. Severe signs and death can occur below any reported median lethal-dose range."}
          }[r.band];
          if(r.species==="cat")d.desc="Canine thresholds are shown only as context. Feline clinical thresholds are not validated. "+d.desc;
          return d;
        }

        function warnings(r){
          var out=[];
          if(r.species==="cat")out.push(["caution","<strong>Cat exposure:</strong> The numeric dose is useful, but the clinical bands are derived from dogs. Obtain veterinary or poison-service advice."]);
          if(r.type==="dark_unknown")out.push(["caution","<strong>Dark chocolate uncertainty:</strong> This result uses 5.3 to 15.5 mg/g and follows the upper estimate. Recalculate with the wrapper's cocoa percentage if available."]);
          if(r.type==="mixed")out.push(["caution","<strong>Mixed product:</strong> Use the recipe's actual cocoa or chocolate amount, not the final food weight."]);
          if(r.type==="unknown")out.push(["warning","<strong>Unknown product:</strong> Do not assume milk chocolate. Milk chocolate and cocoa powder differ by more than twelvefold."]);
          if(r.amountUnknown)out.push(["warning","<strong>Unknown amount:</strong> A reassuring dose cannot be calculated. Keep the package or recipe and use the maximum possible amount when speaking to a vet."]);
          if(r.type==="white")out.push(["caution","<strong>White chocolate:</strong> Methylxanthines are usually negligible, but fat and sugar can still cause vomiting, diarrhoea or pancreatitis."]);
          if(r.type==="cocoa_hulls")out.push(["info","<strong>Cocoa mulch variation:</strong> Some products have methylxanthines removed. This calculator uses 9 mg/g."]);
          if(r.xylitol!=="no")out.push(["warning","<strong>Xylitol warning:</strong> Xylitol, birch sugar or E967 is a separate emergency toxin in dogs. This calculator does not estimate its dose."]);
          if(has(r.flags,"raisins"))out.push(["warning","<strong>Grape and raisin warning:</strong> This creates a separate poisoning risk, especially in dogs."]);
          if(has(r.flags,"caffeine"))out.push(["warning","<strong>Added caffeine:</strong> Coffee, espresso and added caffeine make the displayed methylxanthine estimate incomplete."]);
          if(has(r.flags,"cannabis"))out.push(["warning","<strong>Cannabis or THC:</strong> Tell the veterinary team exactly what was in the edible."]);
          if(has(r.flags,"alcohol"))out.push(["warning","<strong>Alcohol:</strong> This is a separate intoxication risk that the chocolate result does not measure."]);
          if(has(r.flags,"macadamia")&&r.species==="dog")out.push(["caution","<strong>Macadamia nuts:</strong> These can cause a separate toxicosis in dogs."]);
          if(has(r.flags,"wrapper"))out.push(["caution","<strong>Packaging:</strong> Foil or plastic can cause choking or gastrointestinal obstruction."]);
          return out;
        }

        function doNow(r){
          var items=[];
          if(r.care==="emergency"){items.push("Call the nearest emergency clinic and leave now","Call ahead so the team can prepare")}
          else if(r.care==="urgent"){items.push("Contact a veterinarian or animal poison service immediately","Arrange urgent in-person assessment if directed")}
          else if(r.care==="call")items.push("Contact your vet or an animal poison service now");
          else items.push("Monitor closely for at least 24 hours");
          items.push("Keep and photograph the wrapper, ingredient list or recipe");
          if(r.time==="under_2h"&&!has(r.flags,"mild_signs")&&!has(r.flags,"severe_signs"))items.push("Mention that ingestion was within two hours because this may change veterinary decontamination options");
          else if(r.time==="unknown")items.push("Try to establish the earliest and latest possible ingestion time");
          items.push("Do not induce vomiting or give home treatments unless a veterinary professional directs you");
          if(r.care!=="monitor")items.push("Do not wait for symptoms before making contact");
          return items;
        }

        function watch(r){
          var items=["Vomiting, diarrhoea or abdominal discomfort","Restlessness, hyperactivity, panting or unusual thirst","Fast or irregular heartbeat"];
          if(r.band==="cardiac"||r.band==="critical"||r.care==="emergency")items.push("Tremors, twitching, seizures, weakness or collapse");
          items.push("Persistent vomiting or abdominal pain that could indicate pancreatitis");
          if(r.xylitol!=="no"&&r.species==="dog")items.push("Weakness, wobbliness, collapse or seizures that may indicate low blood glucose");
          return items;
        }

        function summaryHtml(r){
          var flags=r.flags.concat(r.patientFlags).map(function(x){return FLAG_LABELS[x]}).filter(Boolean);
          if(r.xylitol!=="no")flags.push(r.xylitol==="yes"?"xylitol listed":"possible xylitol");
          var pairs=[
            ["Pet",r.species==="cat"?"Cat":"Dog"],
            ["Body weight",fmt(r.weightEntered,2)+" "+r.weightUnit+" ("+fmt(r.weightKg,2)+" kg)"],
            ["Product",r.product.label],
            ["Amount",r.amountUnknown?"Unknown":fmt(r.amountEntered,2)+" "+r.amountUnit],
            ["Time since ingestion",TIME_LABELS[r.time]],
            ["Flags",flags.join(", ")||"None selected"]
          ];
          return pairs.map(function(x){return"<div><dt>"+esc(x[0])+"</dt><dd>"+esc(x[1])+"</dd></div>"}).join("");
        }

        function mathText(r){
          var lines=["Body weight: "+fmt(r.weightEntered,3)+" "+r.weightUnit+" = "+fmt(r.weightKg,3)+" kg"];
          if(r.grams===null)lines.push("Amount: unknown, so no numeric dose was calculated");
          else lines.push("Amount: "+fmt(r.amountEntered,3)+" "+r.amountUnit+" = "+fmt(r.grams,3)+" g");
          if(r.product.calculable){
            lines.push("Concentration: "+range(r.product.min,r.product.max,3)+" mg/g total methylxanthines");
            if(r.grams!==null){
              lines.push("Total: "+fmt(r.grams,3)+" g × "+range(r.product.min,r.product.max,3)+" mg/g = "+range(r.totalMin,r.totalMax,2)+" mg");
              lines.push("Exposure: "+range(r.totalMin,r.totalMax,2)+" mg ÷ "+fmt(r.weightKg,3)+" kg = "+doseRange(r.doseMin,r.doseMax)+" mg/kg");
              lines.push("Canine reference band uses the upper, unrounded estimate: "+{below:"below 20 mg/kg",mild:"20 to <40 mg/kg",cardiac:"40 to <60 mg/kg",critical:"60 mg/kg or above"}[r.band]);
            }
          }else lines.push("Concentration: not calculable from the selected product information");
          lines.push("Recommended action: "+r.care.toUpperCase()+". This is separate from the numeric dose band.");
          if(r.reasons.length)lines.push("Action reasons: "+r.reasons.join("; "));
          return lines.join("\n");
        }

        function renderList(el,items){el.innerHTML=items.map(function(x){return"<li>"+esc(x)+"</li>"}).join("")}

        function render(r,moveFocus){
          lastResult=r;
          q("#aavChocEmpty").hidden=true;
          q("#aavChocResult").hidden=false;
          qa('[data-action="print"]').forEach(function(btn){btn.disabled=false});
          var action=actionCopy(r),dose=doseCopy(r);
          q("#aavChocResultHead").className="result-head "+r.care;
          q("#aavChocActionLabel").textContent=r.care==="monitor"?"Estimated action":"Recommended action";
          q("#aavChocResultTitle").textContent=action.title;
          q("#aavChocActionText").textContent=action.text;
          q("#aavChocDoseVerdict").className="dose-verdict "+(r.band||"unknown");
          q("#aavChocDoseLabel").textContent=r.species==="cat"?"Canine dose band shown for context":"Calculated chocolate exposure";
          q("#aavChocDoseTitle").textContent=dose.title;
          q("#aavChocDoseDesc").textContent=dose.desc;
          q("#aavChocDoseValue").textContent=doseRange(r.doseMin,r.doseMax);
          q("#aavChocTotalValue").textContent=range(r.totalMin,r.totalMax,1);
          q("#aavChocConcValue").textContent=r.product.calculable?range(r.product.min,r.product.max,2):"Not known";
          q("#aavChocScale").hidden=!r.band;
          qa("#aavChocScale .risk-step").forEach(function(step){step.classList.toggle("current",step.getAttribute("data-band")===r.band)});
          q("#aavChocAlerts").innerHTML=warnings(r).map(function(x){return'<div class="callout '+x[0]+'">'+x[1]+"</div>"}).join("");
          q("#aavChocSummary").innerHTML=summaryHtml(r);
          renderList(q("#aavChocDoNow"),doNow(r));
          renderList(q("#aavChocWatch"),watch(r));
          q("#aavChocMath").textContent=mathText(r);
          q("#aavChocAppCta").hidden=r.care!=="monitor";
          q("#aavChocCopyStatus").textContent="";
          var live=q("#aavChocLive");
          live.setAttribute("aria-live",r.care==="emergency"?"assertive":"polite");
          live.textContent=action.title+". "+action.text;
          if(moveFocus){
            var title=q("#aavChocResultTitle");
            window.requestAnimationFrame(function(){
              title.focus({preventScroll:true});
              title.scrollIntoView({behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"start"});
            });
          }
        }

        function run(moveFocus){
          var immediate=syncImmediateAlert(false),v=validate();
          if(v)render(assess(v),moveFocus);
          else if(immediate&&moveFocus)syncImmediateAlert(true);
        }

        function updateType(){
          var type=q("#aavChocType").value;
          q("#aavChocPercentField").hidden=type!=="cocoa_percent";
          q("#aavChocCustomField").hidden=type!=="custom";
          if(type!=="cocoa_percent")setError(q("#aavChocPercent"),q("#aavChocPercentError"),false);
          if(type!=="custom")setError(q("#aavChocCustom"),q("#aavChocCustomError"),false);
        }
        function updateUnknown(){
          var unknown=q("#aavChocAmountUnknown").checked;
          q("#aavChocAmount").disabled=unknown;
          q("#aavChocAmountUnit").disabled=unknown;
          if(unknown){q("#aavChocAmount").value="";setError(q("#aavChocAmount"),q("#aavChocAmountError"),false)}
        }
        function refreshChecks(){
          qa(".check").forEach(function(label){
            var input=label.querySelector("input");
            label.classList.toggle("is-on",!!(input&&input.checked));
          });
        }

        function plainText(r){
          var action=actionCopy(r),dose=doseCopy(r);
          var flags=r.flags.concat(r.patientFlags).map(function(x){return FLAG_LABELS[x]}).filter(Boolean);
          if(r.xylitol!=="no")flags.push(r.xylitol==="yes"?"xylitol listed":"possible xylitol");
          return[
            "ASK A VET™ Chocolate Toxicity Calculator",
            "Pet: "+(r.species==="cat"?"Cat":"Dog"),
            "Weight: "+fmt(r.weightEntered,2)+" "+r.weightUnit+" ("+fmt(r.weightKg,2)+" kg)",
            "Product: "+r.product.label,
            "Amount: "+(r.amountUnknown?"Unknown":fmt(r.amountEntered,2)+" "+r.amountUnit+" ("+fmt(r.grams,2)+" g)"),
            "Time: "+TIME_LABELS[r.time],
            "Concentration: "+(r.product.calculable?range(r.product.min,r.product.max,2)+" mg/g":"Not known"),
            "Total methylxanthines: "+range(r.totalMin,r.totalMax,1)+" mg",
            "Exposure: "+doseRange(r.doseMin,r.doseMax)+" mg/kg",
            "Dose interpretation: "+dose.title,
            "Recommended action: "+action.title+". "+action.text,
            "Flags: "+(flags.join(", ")||"None selected"),
            "Do not induce vomiting or give home treatments unless directed by a veterinary professional.",
            "Calculation aid only. Product concentration and individual response vary."
          ].join("\n");
        }
        function fallbackCopy(text,status){
          var area=document.createElement("textarea");
          area.value=text;area.setAttribute("readonly","");area.style.position="fixed";area.style.opacity="0";
          root.appendChild(area);area.select();
          try{document.execCommand("copy");status.textContent="Result copied."}
          catch(err){status.textContent="Copy was unavailable. Use Print result instead."}
          root.removeChild(area);
        }
        function copyResult(){
          if(!lastResult)return;
          var text=plainText(lastResult),status=q("#aavChocCopyStatus");
          if(navigator.clipboard&&window.isSecureContext){
            navigator.clipboard.writeText(text).then(function(){status.textContent="Result copied."}).catch(function(){fallbackCopy(text,status)});
          }else fallbackCopy(text,status);
        }
        function preparePrint(){if(lastResult)document.body.classList.add("aav-choc-printing")}
        function finishPrint(){document.body.classList.remove("aav-choc-printing")}
        function printResult(){
          if(!lastResult)return;
          preparePrint();
          window.print();
          window.setTimeout(finishPrint,1000);
        }
        function editDetails(){
          var heading=q("#aavChocInputTitle"),reduced=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          heading.focus({preventScroll:true});
          heading.scrollIntoView({behavior:reduced?"auto":"smooth",block:"start"});
        }
        function resetAll(){
          form.reset();species="dog";lastResult=null;
          qa("#aavChocSpecies button").forEach(function(btn){btn.setAttribute("aria-pressed",btn.getAttribute("data-species")==="dog"?"true":"false")});
          qa('[aria-invalid="true"]').forEach(function(el){el.setAttribute("aria-invalid","false")});
          qa(".error").forEach(function(el){el.hidden=true});
          updateType();updateUnknown();updateWeightConfirmation();refreshChecks();
          q("#aavChocResult").hidden=true;q("#aavChocEmpty").hidden=false;
          q("#aavChocEmptyTitle").textContent="Your result will appear here";
          q("#aavChocEmptyText").textContent="The calculator deliberately keeps two things separate:";
          q("#aavChocImmediate").hidden=true;q("#aavChocImmediate").textContent="";
          qa('[data-action="print"]').forEach(function(btn){btn.disabled=true});
          finishPrint();
          q("#aavChocLive").textContent="Calculator reset.";
          q("#aavChocWeight").focus();
        }

        q("#aavChocSpecies").addEventListener("click",function(event){
          var btn=event.target.closest("button[data-species]");
          if(!btn)return;
          species=btn.getAttribute("data-species");
          qa("#aavChocSpecies button").forEach(function(item){item.setAttribute("aria-pressed",item===btn?"true":"false")});
          q("#aavChocWeightConfirm").checked=false;
          updateWeightConfirmation();
          invalidateResult();
          syncImmediateAlert(false);
        });
        form.addEventListener("submit",function(event){event.preventDefault();run(true)});
        form.addEventListener("input",function(event){
          if(event.target.type==="checkbox")return;
          invalidateResult();syncImmediateAlert(false);
        });
        q("#aavChocType").addEventListener("change",updateType);
        q("#aavChocAmountUnknown").addEventListener("change",updateUnknown);
        q("#aavChocWeight").addEventListener("input",function(){q("#aavChocWeightConfirm").checked=false;updateWeightConfirmation()});
        q("#aavChocWeightUnit").addEventListener("change",function(){q("#aavChocWeightConfirm").checked=false;updateWeightConfirmation()});
        root.addEventListener("change",function(event){
          if(event.target.matches('input[type="checkbox"]'))refreshChecks();
          invalidateResult();
          syncImmediateAlert(false);
        });
        root.addEventListener("click",function(event){
          var el=event.target.closest("[data-action]");
          if(!el)return;
          var action=el.getAttribute("data-action");
          if(action==="reset")resetAll();
          else if(action==="print")printResult();
          else if(action==="copy")copyResult();
          else if(action==="edit")editDetails();
        });
        window.addEventListener("beforeprint",preparePrint);
        window.addEventListener("afterprint",finishPrint);
        updateType();updateUnknown();updateWeightConfirmation();refreshChecks();

      this.__ctcCleanup = function() {
        try { window.removeEventListener("beforeprint", preparePrint); } catch (e) {}
        try { window.removeEventListener("afterprint", finishPrint); } catch (e) {}
        try { document.body.classList.remove("aav-choc-printing"); } catch (e) {}
      };
    }

    disconnectedCallback() {
      if (this.__ctcCleanup) this.__ctcCleanup();
      this.__ctcCleanup = null;
      this.__ctcInitialized = false;
    }
  }

  if (!customElements.get("s-chocolate-toxicity-calculator")) {
    customElements.define("s-chocolate-toxicity-calculator", SChocolateToxicityCalculator);
  }
})();
